import React from 'react'
import styled from '@emotion/styled'

import { BMonogram } from '../svgs/BMonogram'

const ContextWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	width: 100%;

	svg {
		left: 0;
	}

	${({ theme }) => theme.MQ.M} {
		svg {
			width: 65px;
		}
	}
`
const Message = styled.div`
	font-size: 16px;
	padding: 0 1rem;
	margin: auto 0;
	width: 100%;
	${({ modalView }) =>
		modalView === 'peeking' &&
		`position: absolute;
		left: 0;
		text-align: center;
		`}
	${({ theme }) => theme.MQ.M} {
		align-items: center;
		display: flex;
		padding: 0 2rem;
		font-size: 18px;
		position: relative;
		text-align: left;
	}
	${({ theme }) => theme.MQ.L} {
		font-size: 20px;
	}
`

export function FloaterBarContextBdc({ isMobileView, modalView }) {
	return (
		<>
			<ContextWrapper>
				<BMonogram width={30} />
				<Message modalView={modalView}>
					{isMobileView && modalView === 'peeking'
						? 'Build Your Business'
						: 'Build your business with the best resources on finance, marketing, HR and more.'}
				</Message>
			</ContextWrapper>
		</>
	)
}
